// import { prevent } from 'common/prevent';
import { InteractiveTag, TagsContainer } from 'naan/primitives/tags';
import * as React from 'react';
import { FilterBox } from './filter-box';

import { AnimatedTagsContainer } from './animated-tags-container';
import { VSpacer } from '@naan/primitives/spacer';
import { AppFactory } from '@app/app-factory';

export const CountriesFilterPanel = ({ show = false }: { show: boolean }) => {
  const { storyManager } = AppFactory.root;
  const list = storyManager.countryList;

  return (
    <AnimatedTagsContainer show={show}>
      <VSpacer size="2" />
      <TagsContainer className="wrapper">
        <FilterBox
          filterItems={list}
          filterQueryKey={'countries'}
          renderFilterControl={(item, selected, action) => {
            return (
              <InteractiveTag
                role="button"
                selected={selected}
                onSelect={action}
                type="country"
              >
                {item}
              </InteractiveTag>
            );
          }}
        />
      </TagsContainer>
      <VSpacer size="2" />
    </AnimatedTagsContainer>
  );
};
